//import { ComplaintsTypeGridComponent } from './masters/Complaints-types/complaints-type-grid/complaints-type-grid.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';

//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import { DatePipe } from '@angular/common';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { DistrictGridComponent } from './masters/district/district-grid/district-grid.component';

import { DistrictFormComponent } from './masters/district/district-form/district-form.component';
import { DistrictComponent } from './masters/district/district.component';
import { MastersComponent } from './masters/masters.component';
//import { MasterMenuComponent } from './masters/master-menu/master-menu.component';
import { VehicleGridComponent } from './ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CorrespondanceTrackingComponent } from './correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './correspondance-tracking/ct-form/ct-form.component';
import { CtMenuComponent } from './correspondance-tracking/ct-menu/ct-menu.component';
import { TalukComponent } from './masters/taluk/taluk.component';
import { TalukGridComponent } from './masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './ultilities/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './ultilities/office/office-form/office-form.component';
import { FooterComponent } from './common/footer/footer.component';
//import { ComplaintsTypeFormComponent } from './masters/Complaints-types/complaints-type-form/complaints-type-form.component';
import { EnactmentFormComponent } from './masters/Enactment/enactment-form/enactment-form.component';
import { EnactmentGridComponent } from './masters/Enactment/enactment-grid/enactment-grid.component';
import { MaintenanceFormComponent } from './masters/Maintenance-office/maintenance-form/maintenance-form.component';
import { ComplaintsComponent } from './Complaints/complaints.component';
import { ComplaintsFormComponent } from './Complaints/complaints-form/complaints-form.component';
import { JurisdictionGridComponent } from './masters/Jurisdiction/jurisdiction-grid/jurisdiction-grid.component';
import { JurisdictionFormComponent } from './masters/Jurisdiction/jurisdiction-form/jurisdiction-form.component';
import { MaintenanceGridComponent } from './masters/Maintenance-office/maintenance-grid/maintenance-grid.component';
import { ComplaintGridComponent } from './Complaints/complaint-grid/complaint-grid.component';
import { InvestigationDocsComponent } from './investigation-docs/investigation-docs.component';

import { InvDocGridComponent } from './investigation-docs/inv-doc-grid/inv-doc-grid.component';
import { FirFormComponent } from './FIR/fir-form/fir-form.component';
import { FirGridComponent } from './FIR/fir-grid/fir-grid.component';
import { FirComponent } from './FIR/fir.component';
import {DepartmentFormComponent} from './masters/department/department-form/department-form.component';
import {DepartmentGridComponent} from './masters/department/department-grid/department-grid.component';
import { FirProceGridComponent } from './investigation-docs/fir-proceeding-list/fir-proce-grid/fir-proce-grid.component';
import { InvestigationGridComponent } from './investigationdocs-for-investigation/investigation-grid/investigation-grid.component';
import { InvestigationFormComponent } from './investigationdocs-for-investigation/investigation-form/investigation-form.component';
import { DeptDocumentFormComponent } from './masters/dept-document/dept-document-form/dept-document-form.component';
import { DeptDocumentGridComponent } from './masters/dept-document/dept-document-grid/dept-document-grid.component';
import { InvestmentCreationGridComponent } from './investment/investment-creation-grid/investment-creation-grid.component';
import { InvestmentMenuComponent } from './investment/investment-menu/investment-menu.component';
import { InvestmentComponent } from './investment/investment.component';
import { ReportsComponent } from './reports/reports.component';
import { AppreportComponent } from './reports/appreport/appreport.component';
import { ReportmenuComponent } from './reports/reportmenu/reportmenu.component';
import { MasterAccountComponent } from './master-account/master-account.component';
import { MemberCreationComponent } from './master-account/member-creation/member-creation.component';
import { AccountmasterMenuComponent } from './master-account/accountmaster-menu/accountmaster-menu.component';
import { MemberCreationGridComponent } from './master-account/member-creation-grid/member-creation-grid.component';
import { SbAccountGridComponent } from './master-account/sb-account-grid/sb-account-grid.component';
import { SbAccountComponent } from './master-account/sb-account/sb-account.component';
import { NewDepositGridComponent } from './master-account/new-deposit-grid/new-deposit-grid.component';
import { NewDepositComponent } from './master-account/new-deposit/new-deposit.component';
import { UnicoreMastersComponent } from './unicore-masters/unicore-masters.component';
import { CustomerCreationGridComponent } from './unicore-masters/customer-creation-grid/customer-creation-grid.component';
import { MasterMenuComponent } from './unicore-masters/master-menu/master-menu.component';
import { CustomerCreationComponent } from './unicore-masters/customer-creation/customer-creation.component';
import { AgentCreationGridComponent } from './unicore-masters/agent-creation-grid/agent-creation-grid.component';
import { AgentCreationsComponent } from './unicore-masters/agent-creations/agent-creations.component';
import { GeneralTransactionComponent } from './general-transaction/general-transaction.component';
import { GeneraltransactionMenuComponent } from './general-transaction/generaltransaction-menu/generaltransaction-menu.component';
import { ExportToMachineComponent } from './general-transaction/export-to-machine/export-to-machine.component';
import { ImportFromMachineComponent } from './general-transaction/import-from-machine/import-from-machine.component';
import { PigmyremittanceGridComponent } from './general-transaction/pigmyremittance-grid/pigmyremittance-grid.component';
import { PigmyremittanceComponent } from './general-transaction/pigmyremittance/pigmyremittance.component';
import { ReceiptCreditGridComponent } from './general-transaction/recepit-credit-grid/recepit-credit-grid.component';
import { ReceiptCreditComponent } from './general-transaction/recepit-credit/recepit-credit.component';
import { PigmyPartpaymentComponent } from './general-transaction/pigmy-partpayment/pigmy-partpayment.component';
import { PigmyManualcollectionComponent } from './general-transaction/pigmy-manualcollection/pigmy-manualcollection.component';
import { AccountClosureComponent } from './master-account/account-closure/account-closure.component';
import { OthertransactionComponent } from './othertransaction/othertransaction.component';
import { OthertransactionMenuComponent } from './othertransaction/othertransaction-menu/othertransaction-menu.component';
import { PigmyMonthlyTransferComponent } from './othertransaction/pigmy-monthly-transfer/pigmy-monthly-transfer.component';
import { PigmyCreationComponent } from './master-account/pigmy-creation/pigmy-creation.component';
import { PigmyCreationGridComponent } from './master-account/pigmy-creation-grid/pigmy-creation-grid.component';
import { TransactionReportComponent } from './reports/transaction-report/transaction-report.component';
import { ScheduleReportComponent } from './reports/schedule-report/schedule-report.component';
import { VoucherReportComponent } from './reports/voucher-report/voucher-report.component';
import { AgentTransferFormComponent } from './general-transaction/agent-transfer/agent-transfer-form/agent-transfer-form.component';
import { ValidateAccountsComponent } from './general-transaction/validate-accounts/validate-accounts/validate-accounts.component';
import { ChitsReportsComponent } from './reports/chits-reports/chits-reports.component';
import { SchemecreationComponent } from './chitfund/schemecreation/schemecreation.component';
import { ChitfundmenuComponent } from './chitfund/chitfundmenu/chitfundmenu.component';
import { ChitfundComponent } from './chitfund/chitfund.component';
// import { ChitCreationComponent } from './chitfund/chit-creation/chit-creation.component';
import { ChitClaimComponent } from './chitfund/chit-claim/chit-claim.component';
import { ChitmemberTransferComponent } from './chitfund/chitmember-transfer/chitmember-transfer.component';
import { ScheduleGenerateComponent } from './chitfund/schedule-generate/schedule-generate.component';
import { ChitReceiptComponent } from './chitfund/chit-receipt/chit-receipt.component';
import { MiscellaneousReceiptComponent } from './chitfund/miscellaneous-receipt/miscellaneous-receipt.component';
import { ChitPaymentComponent } from './chitfund/chit-payment/chit-payment.component';
import { ChitreportsComponent } from './reports/chitreports/chitreports.component';
import { HelpComponent } from './help/help.component';
import { VoucherSearchComponent } from './help/voucher-search/voucher-search.component';
import { VoucherSearchmenuComponent } from './help/voucher-searchmenu/voucher-searchmenu.component';
 import { GlTransactionComponent } from './reports/gl-transaction/gl-transaction.component';
import { FinancialReportComponent } from './reports/financial-report/financial-report.component';
import { SbIntrestCalculationComponent } from './othertransaction/sb-intrest-calculation/sb-intrest-calculation.component';
import { ChitCreationComponent } from './chitfund/chit-creation/chit-creation.component';
import { SchemeCreationGridComponent } from './unicore-masters/scheme-creation/scheme-creation-grid/scheme-creation-grid.component';
import { SchemeCreationFormComponent } from './unicore-masters/Scheme-Creation/scheme-creation-form/scheme-creation-form.component';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    DistrictGridComponent,
    DistrictFormComponent,
    DistrictComponent,
    MastersComponent,
    MasterMenuComponent,
    VehicleGridComponent,
    VehicleFormComponent,
    CorrespondanceTrackingComponent,
    CtGridComponent,
    CtFormComponent,
    CtMenuComponent,
    TalukComponent,
    TalukGridComponent,
    TalukFormComponent,
    OfficeGridComponent,
    OfficeFormComponent,
    FooterComponent,
    //ComplaintsTypeGridComponent,
    //ComplaintsTypeFormComponent,
    EnactmentGridComponent,
    EnactmentFormComponent,
    MaintenanceGridComponent,
    MaintenanceFormComponent,
    ComplaintsComponent,
    ComplaintsFormComponent,
    JurisdictionGridComponent,
    JurisdictionFormComponent,
    ComplaintGridComponent,
    InvestigationDocsComponent,    
    InvDocGridComponent,
    FirComponent,
    FirGridComponent,
    FirFormComponent,
    DepartmentFormComponent,
    DepartmentGridComponent,
    FirProceGridComponent,  
    ForgotPasswordComponent, 
    InvestigationGridComponent, 
    InvestigationFormComponent, 
    DeptDocumentFormComponent, 
    DeptDocumentGridComponent,
    InvestmentCreationGridComponent,
    InvestmentMenuComponent,
    InvestmentComponent,
    HelpComponent,
    VoucherSearchComponent,
    VoucherSearchmenuComponent,
    
    ReportsComponent,
    AppreportComponent,
    ReportmenuComponent,
    MasterAccountComponent,   
    MemberCreationComponent,
    AccountmasterMenuComponent,
    MemberCreationGridComponent,
    SbAccountGridComponent,
    SbAccountComponent,
    NewDepositGridComponent,
    NewDepositComponent,
    UnicoreMastersComponent,
    CustomerCreationGridComponent,
    CustomerCreationComponent,
    AgentCreationGridComponent,
    AgentCreationsComponent,
    GeneralTransactionComponent,
    GeneraltransactionMenuComponent,
    ExportToMachineComponent,
    ImportFromMachineComponent,
    PigmyremittanceGridComponent,
    PigmyremittanceComponent,
    ReceiptCreditGridComponent,
    ReceiptCreditComponent,
    PigmyPartpaymentComponent,
    PigmyManualcollectionComponent,
    AccountClosureComponent,
    OthertransactionComponent,
    OthertransactionMenuComponent,
    PigmyMonthlyTransferComponent,
    PigmyCreationGridComponent,
    PigmyCreationComponent,
    TransactionReportComponent,
    ScheduleReportComponent,
    VoucherReportComponent,
    AgentTransferFormComponent,
    ValidateAccountsComponent,
    ChitsReportsComponent,  
    SchemecreationComponent, ChitfundmenuComponent,
    ChitfundComponent,
    // ChitCreationComponent,
    ChitClaimComponent,
    ChitmemberTransferComponent,
    ScheduleGenerateComponent,
    ChitReceiptComponent,
    MiscellaneousReceiptComponent,
    ChitPaymentComponent,
    ChitreportsComponent,
     GlTransactionComponent,
    FinancialReportComponent,
    SbIntrestCalculationComponent,
    ChitCreationComponent,
    SchemeCreationGridComponent,
    SchemeCreationFormComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [UserService,DatePipe,ErrorHandler,AuthGuard,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
    
],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts